import { createAction } from '@reduxjs/toolkit';

// Kept as a standalone action so Redux slices can reset their state on logout.
export const logout = createAction('user/logout');
